import React, { useState } from 'react';
import { Sheet } from 'react-modal-sheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import icons from '../icons/Icons';
import './WaiterBottomSheet.css';

const WaiterBottomSheet = ({ isOpen, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [callStatus, setCallStatus] = useState(null); // null, 'success', 'error'

    const handleCallWaiter = async () => {
        setIsLoading(true);
        setCallStatus(null);

        try {
            // Simulate API call for now
            await new Promise(resolve => setTimeout(resolve, 2000));
            
            // TODO: Replace with actual API call
            // const response = await fetch('/api/call-waiter', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify({
            //         tableNumber: 'TABLE_ID', // Get from context or props
            //         timestamp: new Date().toISOString()
            //     })
            // });
            
            // if (!response.ok) {
            //     throw new Error('Failed to call waiter');
            // }
            
            setCallStatus('success');
            console.log('Waiter called successfully - showing success state');
            
            // Auto close after success message
            setTimeout(() => {
                onClose();
                setCallStatus(null);
            }, 3000);
            
        } catch (error) {
            console.error('Error calling waiter:', error);
            setCallStatus('error');
            
            // Auto reset error after 3 seconds
            setTimeout(() => {
                setCallStatus(null);
            }, 3000);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        if (!isLoading) {
            setCallStatus(null);
            onClose();
        }
    };

    return (
        <Sheet isOpen={isOpen} onClose={handleClose} disableScrollLocking={true} detent='content'>
            <Sheet.Container>
                <Sheet.Header>
                    <div className="sheet-header">
                        <h2>Call Waiter</h2>
                        <button 
                            className="close-btn" 
                            onClick={handleClose}
                            disabled={isLoading}
                        >
                            ×
                        </button>
                    </div>
                </Sheet.Header>
                <Sheet.Content>
                    <div className="waiter-content">
                        {callStatus === 'success' ? (
                            <div className="status-message success">
                                <div className="status-icon">
                                    <FontAwesomeIcon 
                                        icon={icons.checkCircle} 
                                        size="4x"
                                        color="#38dc5e"
                                    />
                                </div>
                                <h3>Waiter Called Successfully!</h3>
                                <p>A waiter will be at your service soon. Please wait for assistance.</p>
                            </div>
                        ) : callStatus === 'error' ? (
                            <div className="status-message error">
                                <div className="status-icon">
                                    <FontAwesomeIcon 
                                        icon={icons.exclamationTriangle} 
                                        size="4x"
                                        color="#38dc5e"
                                    />
                                </div>
                                <h3>Unable to Call Waiter</h3>
                                <p>Please try again or call our service number.</p>
                            </div>
                        ) : (
                            <>
                                <div className="waiter-icon">
                                    <FontAwesomeIcon 
                                        icon={icons.userTie} 
                                        size="4x"
                                        color="#000000"
                                    />
                                </div>
                                
                                <div className="waiter-text">
                                    <h3>Need Assistance?</h3>
                                    <p>Our waiter will come to your table to help you within a few seconds.</p>
                                </div>
                                
                                <button 
                                    className="call-waiter-btn"
                                    onClick={handleCallWaiter}
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <>
                                            <div className="loading-dots">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                            Calling Waiter...
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon color="#ffffff" icon={icons.bell} style={{marginRight: '8px'}} />
                                            Call Waiter
                                        </>
                                    )}
                                </button>
                            </>
                        )}
                    </div>
                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onTap={handleClose} />
        </Sheet>
    );
};

export default WaiterBottomSheet;
